export default __webpack_public_path__ + "static/media/amazoneClone1.51cd3f3a.png";